import SimpleToggle from '@/components/UI/Toggle/SimpleToggle';
import { useAssignWidgetToClientAccount, useUnassignWidgetToClientAccount } from '../../../../../hooks/ReactQueryHooks/useDashboardQuery';
import type { WidgetInterface } from '../../types';

export interface WidgetListItemProps {
  widget: WidgetInterface;
  accountId: number;
}

const WidgetListItem = (props: WidgetListItemProps) => {
  const { widget, accountId } = props;

  const assignWidgetToClientAccount = useAssignWidgetToClientAccount();
  const unassignWidgetToClientAccount = useUnassignWidgetToClientAccount();

  const assignWidgetHandler = (widgetId: number) => {
    const finalData = { widgetId: widgetId, accountId };
    assignWidgetToClientAccount.mutate(finalData);
  };

  const unassignWidgetHandler = (widgetId: number) => {
    const finalData = { widgetId: widgetId, accountId };
    unassignWidgetToClientAccount.mutate(finalData);
  };

  const toggleHandler = () => {
    if (widget.isAssigned) {
      unassignWidgetHandler(widget.id);
    } else {
      assignWidgetHandler(widget.id);
    }
  };

  return (
    <div className='flex gap-4 justify-between cursor-pointer py-5 border-b'>
      <div className='gap-3 w-full'>
        <div className='flex gap-3'>
          <span className='text-neutralColor-normal'>{widget.icon}</span>
          <h5 className='font-bold text-sm'>{widget.name}</h5>
        </div>
        <small className='ml-8 text-xs text-gray-500'>{widget.description}</small>
      </div>
      <div className='ml-8'>
        <SimpleToggle enabled={widget.isAssigned} handleToggle={toggleHandler} />
      </div>
    </div>
  );
};

export default WidgetListItem;
